import {h, Component, createRef} from 'preact'
import menuObjectService from "../service/menuObjectService";
import util, {cleanDots} from "../util";
import constants from "../constants";
import MenuObject from "../canvas/menu-object";
import linkRef from "linkref";
import store from "../store";
import * as actions from "../actions";
import Spinner from '../component/Spinner';
import {formatSizeAndPrice} from "../canvas/menu-object-renderer";
import React from "preact/compat";
import { LeftOutlined } from '@ant-design/icons';


let REFS = [];
const NAME_COMPARE_ASC = (a, b) => a.name.charCodeAt(0) - b.name.charCodeAt(0);
let ITEMS = [];

export default class MenuContentImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectAll: false,
      items: props.items ?? [],
      sort: 'default',
      isLoading: false,
      listTopCoord: store.getState().isMobileVersion ? 135 : 185,
    }
  }

  populateItems(nextDesignId) {
    const designId = nextDesignId || this.props.designId;
    if (!designId) return;

    this.setState({isLoading: true});
    menuObjectService.getDesignMenuItems(designId).then(resp => {
      ITEMS = JSON.parse(JSON.stringify(resp.data));
      const items = this.getItems(resp.data);
      this.setState({items, isLoading: false});
    });
  }

  populateOnlineMenuItems(onlineMenuImport) {
    this.setState({isLoading: true});
    const items = this.getItemsFromOnlineMenu(onlineMenuImport || this.props.onlineMenuImport);
    this.setState({items, isLoading: false});
  }

  onItemClick(item) {
    item.selected = !item.selected;
    this.setState({
      selectAll: false,
      items: [...this.state.items]
    });
  }

  addItemsToMenu() {
    const selected = this.state.items.filter(it => it.selected);
    this.props.addItems(selected);
    this.onClose();
  }

  search(ev) {
    const name = ev.target.value.toLowerCase();

    REFS.forEach(it => {
      it.ref.current.classList.remove('act');
    })

    if (!name) return;

    let scrolled = false;
    REFS.forEach(it => {
      if (it.name.indexOf(name) > -1) {
        util.nextTick(() => {
          const element = it.ref.current
          if (!scrolled) {
            element.scrollIntoView();
            scrolled = true;
          }
          element.classList.add('act');
        })
      }
    })
  }

  selectItemsFromSection(ev) {
    const sectionId = ev.target.value;
    const select = ev.target.checked;
    const items = this.state.items;

    items.forEach(it => {
      if (it.groupID === sectionId) {
        it.selected = select;
      }
    })
    this.setState({
      selectAll: false,
      items: [...items]
    });

  }

  sortBy(sort) {
    let items = this.state.items;
    if (sort === 'name') {
      items.sort(NAME_COMPARE_ASC);
    } else {
      items = this.getItems(ITEMS);
    }

    this.setState({
      sort,
      items: [...items]
    });
  }

  getItems(data) {
    return data.map(it => new MenuObject.MenuItem(cleanDots(it.name), it.tag, it.description, it.prices, it.extras, it.bin, it.binHeader, it.menuIcons, it.modifiers, it.objectId, it.groupId));
  }

  getPricesForItem(prices, sizes) {
    return prices.map((price, idx) => {
      if (sizes && sizes.length && price) {
        return {size: sizes[idx], price};
      }
      if (!(sizes && sizes.length) && price) {
        return {size: '', price};
      }
      if (sizes && sizes.length && !price) {
        return {size: sizes[idx], price: ''};
      }

      return {size: '', price: ''};
    });
  }

  getItemsFromOnlineMenu(data) {
    const dataNodes = JSON.parse(data.nodes);
    let omArray = [];

    dataNodes.forEach(it => {
      const sectionElements = it.nodes?.map(item => {
        const prices = this.getPricesForItem(item.prices, item.sizes);
        const icons = item.icons ? item.icons : [];
        const modifiers = item.modifiers ? item.modifiers : [];
        return new MenuObject.MenuItem(cleanDots(item.name), '', item.description, prices, item.extras, "", "", icons, modifiers, item.id, it.id)
      });
      omArray = [...omArray, ...sectionElements];
    });
    return omArray;
  }

  componentDidMount() {
    if (this.props.items) {
      return;
    }
    if(this.props.onlineMenuImport) {
      // const headerHeight = document.getElementById("designHeader").offsetHeight + 30;
      // this.setState({listTopCoord: headerHeight})
      this.populateOnlineMenuItems()
    } else {
      this.populateItems();
    }
  }

  clearSearchField() {
    this.refs.searchField.value = '';
  }

  goBack() {
    this.clearSearchField();
    this.props.onGoBack(this.state.locationId);
  }

  onClose() {
    this.clearSearchField();
    this.props.onClose();
  }

  forceSaveMO() {
    let doneBtn = $('.done-button')[0];
    if (doneBtn) {
      doneBtn.click();
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.onlineMenuImport) {
      // const headerHeight = document.getElementById("designHeader").offsetHeight + 30;
      // this.setState({listTopCoord: headerHeight})
      this.populateOnlineMenuItems(nextProps.onlineMenuImport)
    } else {
      this.populateItems(nextProps.designId);
    }
  }

  saveThenClose() {
    this.forceSaveMO();
    setTimeout(() => {
      store.dispatch(actions.hideMenuContentModal());
    }, 50);
  }

  getContentName() {
    if (this.props.designName) return this.props.designName;
    if (this.props.onlineMenuImport) return this.props.onlineMenuImport.name;
    return '';
  }

  getItemNameObject(html) {
    return $(`<span>${html}</span>`);
  }

  render(props, state) {
    REFS = [];
    let currentSectionId = null;
    const items = state.items?.map(it => {
      let sectionSelector = (<div className="mii-section-selector"></div>)
      if (currentSectionId == null || currentSectionId != it.groupID) {
        sectionSelector = (<div className="mii-section-selector">
          <label className="container">
            <input type="checkbox" value={it.groupID} onClick={(ev) => this.selectItemsFromSection(ev)}/>
            <span className="checkmark"></span>
          </label>
        </div>)
        currentSectionId = it.groupID
      }

      const ref = createRef();
      REFS.push({name: it.name?.toLowerCase(), ref});
      return (<li>{sectionSelector}
        <div ref={ref} className={'item' + (it.selected ? ' sel' : '')} onClick={() => this.onItemClick(it)}
             data-group={it.groupID}>
          <span className="name" dangerouslySetInnerHTML={{ __html: it.name}}></span>
          <span className="price">{util.ellipsis(formatSizeAndPrice(it.prices[0]), 6)}</span>
        </div>
      </li>)
    });

    let selectedCount = state.items.filter(it => it.selected).length;

    return (
        <div className="import-from-saved-designs">
          <header className="tall">
            <div className="go-back-btn" onClick={() => this.goBack()}>
              <LeftOutlined/>
            </div>
            <h4>{props.onlineMenuImport ? 'Import Items from an Online Menu' : props.importFromSampleCopy ? 'Templates | Sample Data' : 'Import Items from a Saved Design'}</h4>
            <div className="search">
              <input type="text" placeholder="Search" onKeyUp={util.debounce(this.search.bind(this))}
                    ref={linkRef(this, 'searchField')}/>
              <svg className="search-icon">
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-search"}/>
              </svg>
            </div>
            <p>Choose items to import</p>
          </header>

          {state.isLoading ? <Spinner/> :
            <div className="modal-content import-items-content items scroller">
              <ul className="items import">{items}</ul>
            </div>}
          <footer>
            <a className={'btn primary accept' + (selectedCount > 0 ? '' : ' disabled')}
              onClick={this.addItemsToMenu.bind(this)}>Add to Design</a>
          </footer>
        </div>
    );
  }
}
